export const SET_LOGIN_TOKEN = 'SET_SESSION_TOKEN'
export const SET_LOGIN_ERROR = 'SET_SESSION_ERROR'
export const START_TRANSITION = 'START_TRANSITION'

export const SET_SESSION_NAMESPACE = 'SET_SESSION_NAMESPACE'
export const SET_STATE = 'SET_STATE'
export const SET_TEAM = 'SET_TEAM'
export const SET_SLIDE_STATE = 'SET_SLIDE_STATE'
export const RESET_SLIDE_STATES = 'RESET_SLIDE_STATES'
